import { defineMessages } from 'react-intl';

export default defineMessages({
	feedbackWidget: {
		defaultMessage: 'Give feedback',
		description: 'The text for give feedback button for help centers management screen',
		id: 'sidebar.feedback.widget',
	},
	backButton: {
		defaultMessage: 'Back to all help centers',
		description: 'The text for the back button in the sidebar',
		id: 'sidebar.back.hc.management.button',
	},
	backButtonHelpHub: {
		defaultMessage: 'Back to help centers',
		description: 'The text for the back button in the sidebar when viewing a help center',
		id: 'sidebar.back.helphub.management.button',
	},
	backButtonWithoutProjectMapping: {
		defaultMessage: 'Back to help center',
		description: 'The text for the back button in the sidebar',
		id: 'sidebar.back.hc.button',
	},
	settingsLabel: {
		defaultMessage: 'Help center settings',
		description: 'Navigation label for the help center settings link in the sidebar',
		id: 'sidebar.settings.label',
	},
	settingsLabelHelpHub: {
		defaultMessage: 'Help center settings',
		description: 'Label for settings when viewing a help center',
		id: 'sidebar.settings.label.helphub',
	},
	sidebarNavigationLabel: {
		defaultMessage: 'Sidebar navigation',
		description: 'Accessible label for the sidebar navigation landmark element',
		id: 'sidebar.navigation.label',
	},
});
